import { 
    SHOW_MESSAGE, 
    HIDE_MESSAGE
} from '../actions/types';

const initialState = {
    modalConfig: {
        show: false,
        type: 'success',
        message: "",
    }
}

export default function(state = initialState, action){
    switch(action.type){
        case SHOW_MESSAGE:
            return {
                ...state,
                modalConfig: {
                    ...state.modalConfig,
                    show: true,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case HIDE_MESSAGE:
            return{
                ...state,
                modalConfig: {
                    ...state.modalConfig,
                    show: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        default:
            return state;
    }
}